export default {"src":"/_next/static/media/Warning-white.89805d14.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};